import axios from '@/libs/api.request';

export const getActionList = data => {
    return axios.request({
        url: 'api/systemManagement/actionManagement/getActionList',
        data: data,
        method: 'post'
    });
};